import { TemplateElement, html, defineElement } from '@webtides/element-js';
import loadScript from '../../../js/util/load-script';

let paypalClientId =
    window.siteConfig().paypalClientId ||
    'ARHO1sKESnTBUoSMVl0tE6QHxWE8YaOf4hZR7j5SbtOfidv4D5m5iDHe6vtBygivsi5hUd085F5r71AK';
let currency = window.siteConfig().currency || 'EUR';

const PP_SDK_URL = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&currency=${currency}&components=messages`;

class PaypalMessage extends TemplateElement {
    constructor() {
        super({
            autoUpdate: false,
        });
    }
    properties() {
        return {
            amount: 500,
            layout: 'text',
            logoType: 'inline',
        };
    }

    connected() {
        if (!window.paypal || !window.paypal.Messages) {
            loadScript(PP_SDK_URL).then(() => this.initMessage());
        } else {
            this.initMessage();
        }
    }

    watch() {
        return {
            amount: amount => {
                this.$refs.message.dataset.ppAmount = amount;
            },
        };
    }

    afterUpdate() {
        this.initMessage();
    }

    initMessage() {
        if (!window.paypal) {
            return;
        }
        // Render each PayPal Credit message
        paypal
            .Messages({
                style: {
                    layout: this.layout,
                    logo: {
                        type: this.logoType,
                    },
                },
            })
            .render(this.$refs.message);

        this.classList.add('mt-4', 'p-4', 'bg-grey-100');
    }

    template() {
        return `<div ref="message" data-pp-message data-pp-amount="${this.amount}"></div>`;
    }
}

defineElement('paypal-messages', PaypalMessage);
